import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "bottom",
    },
    title: {
      display: false,
    },
  },
  scales: {
    y: {
      ticks: {
        callback: function (label, index, labels) {
          return (label / 1000000000).toLocaleString() + " M";
        },
      },
    },
  },
  maintainAspectRatio: false,
};

export default function TargetRealisasi({
  tahun,
  setTahun,
  tambah,
  kurang,
  epnbp,
  kerjasamabu,
  jasaperbankan,
  pendapatanlainlain,
  targetepnbp,
  targetkerjasamabu,
  targetjasaperbankan,
  targetpendapatanlainlain,
}) {
  const [targetEpnbp, setTargetEpnbp] = React.useState(0);
  const [realisasiEpnbp, setRealisasiEpnbp] = React.useState(0);
  const [targetKerjasamabu, setTargetKerjasamabu] = React.useState(0);
  const [realisasiKerjasamabu, setRealisasiKerjasamabu] = React.useState(0);
  const [targetJasaperbankan, setTargetJasaperbankan] = React.useState(0);
  const [realisasiJasaperbankan, setRealisasiJasaperbankan] = React.useState(0);
  const [targetPendapatanlainlain, setTargetPendapatanlainlain] =
    React.useState(0);
  const [realisasiPendapatanlainlain, setRealisasiPendapatanlainlain] =
    React.useState(0);

  React.useEffect(() => {
    if (Object.values(epnbp)[0]) {
      setRealisasiEpnbp(Object.values(epnbp)[0]);
    }
    if (Object.values(targetepnbp)[0]) {
      setTargetEpnbp(Object.values(targetepnbp)[0]);
    }
  }, [epnbp, targetepnbp]);

  React.useEffect(() => {
    if (Object.values(kerjasamabu)[0]) {
      setRealisasiKerjasamabu(Object.values(kerjasamabu)[0]);
    }
    if (Object.values(targetkerjasamabu)[0]) {
      setTargetKerjasamabu(Object.values(targetkerjasamabu)[0]);
    }
  }, [kerjasamabu, targetkerjasamabu]);

  React.useEffect(() => {
    if (Object.values(jasaperbankan)[0]) {
      setRealisasiJasaperbankan(Object.values(jasaperbankan)[0]);
    }
    if (Object.values(targetjasaperbankan)[0]) {
      setTargetJasaperbankan(Object.values(targetjasaperbankan)[0]);
    }
  }, [jasaperbankan, targetjasaperbankan]);

  React.useEffect(() => {
    if (Object.values(pendapatanlainlain)[0]) {
      setRealisasiPendapatanlainlain(Object.values(pendapatanlainlain)[0]);
    }
    if (Object.values(targetpendapatanlainlain)[0]) {
      setTargetPendapatanlainlain(Object.values(targetpendapatanlainlain)[0]);
    }
  }, [pendapatanlainlain, targetpendapatanlainlain]);

  const labels = [
    "KPU/USO",
    "Kerjasama BU",
    "Perbankan",
    "Pendapatan Lain-lain",
  ];
  const datasets = [
    {
      label: "Realisasi Pendapatan",
      data: [],
      backgroundColor: "rgb(28, 97, 232)",
    },
    {
      label: "Target Pendapatan",
      data: [],
      backgroundColor: "rgb(109, 204, 176)",
    },
  ];

  datasets[0].data.push(
    Object.values(epnbp)[0],
    Object.values(kerjasamabu)[0],
    Object.values(jasaperbankan)[0],
    Object.values(pendapatanlainlain)[0]
  );
  datasets[1].data.push(
    Object.values(targetepnbp)[0],
    Object.values(targetkerjasamabu)[0],
    Object.values(targetjasaperbankan)[0],
    Object.values(targetpendapatanlainlain)[0]
  );

  let targetRealisasi = [
    {
      nama_aplikasi: "KPU/USO",
      realisasi: realisasiEpnbp,
      target: targetEpnbp,
      color_aplikasi: "w-4 h-4 bg-success float-left",
    },
    {
      nama_aplikasi: "Kerjasama BU",
      realisasi: realisasiKerjasamabu,
      target: targetKerjasamabu,
      color_aplikasi: "w-4 h-4 bg-navigation float-left",
    },
    {
      nama_aplikasi: "Perbankan",
      realisasi: realisasiJasaperbankan,
      target: targetJasaperbankan,
      color_aplikasi: "w-4 h-4 bg-danger float-left",
    },
    {
      nama_aplikasi: "Pendapatan Lain-lain",
      realisasi: realisasiPendapatanlainlain,
      target: targetPendapatanlainlain,
      color_aplikasi: "w-4 h-4 bg-warning float-left",
    },
  ];

  let renderedTargetRealisasi = targetRealisasi.map((value, index) => {
    return (
      <tr>
        <td className="p-1">
          <div className={value.color_aplikasi}></div>
          <p className="font-semibold text-sm">
            &nbsp;&nbsp;&nbsp;&nbsp;{value.nama_aplikasi}
          </p>
        </td>
        <td className="p-1 text-left">
          <p className="font-semibold text-sm">
            {value.realisasi.toLocaleString()}
          </p>
        </td>
        <td className="p-1 text-left">
          <p className="font-semibold text-sm">
            {value.target.toLocaleString()}
          </p>
        </td>
      </tr>
    );
  });

  const data = {
    labels,
    datasets: datasets,
  };

  const thisYear = new Date().getFullYear();

  const increaseTahun = () => {
    if (tahun + 1 <= thisYear) {
      setTahun((inputTahun) => inputTahun + 1);
    }
  };

  const decreaseTahun = () => {
    if (tahun > 2018) {
      setTahun((inputTahun) => inputTahun - 1);
    }
  };

  return (
    <>
      <div className="bg-primary-second rounded-t-lg px-8 py-6 grid grid-cols-1 md:grid-cols-2">
        <div className="self-center">
          <h3 className="text-base md:text-xl font-semibold text-white">
            Perbandingan Target dan Realisasi Jenis Pendapatan
          </h3>
        </div>
        <div className="self-center mt-2 md:mt-0">
          <div className="flex flex-row justify-center md:justify-end">
            <button
              onClick={decreaseTahun}
              type="button"
              className="px-2 md:px-3 py-1 md:py-2 mr-2 last:mr-0 bg-primary-second text-white rounded-lg border border-neutral-300 hover:bg-primary-main duration-300"
            >
              <svg
                className="w-4 md:w-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </button>

            <p className="flex-1 md:flex-none mr-2 last:mr-0 p-1 md:p-2 text-center text-sm md:text-base bg-primary-second text-white rounded-lg border border-neutral-300 hover:bg-primary-main duration-300">
              {tahun}
            </p>

            <button
              onClick={increaseTahun}
              type="button"
              className="px-2 md:px-3 py-1 md:py-2 mr-2 last:mr-0 bg-primary-second text-white rounded-lg border border-neutral-300 hover:bg-primary-main duration-300"
            >
              <svg
                className="w-4 md:w-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div className="p-8">
        <div className="grid grid-cols-1 gap-3">
          <div className="h-64 md:h-72">
            <Bar options={options} data={data} />
          </div>
          <div className="p-4 border border-neutral-300 rounded-lg bg-gray-light hidden md:block">
            <table className="table-auto min-w-full">
              <thead>
                <tr>
                  <th className="p-1"></th>
                  <th className="p-1 text-left">Realisasi</th>
                  <th className="p-1 text-left">Target</th>
                </tr>
              </thead>
              <tbody>{renderedTargetRealisasi}</tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
